export var TreeEvent;
(function (TreeEvent) {
    TreeEvent["check"] = "check";
    TreeEvent["select"] = "select";
})(TreeEvent || (TreeEvent = {}));
